import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import SegmentationLine from './SegmentationLine';
const SegmentationTable = (t0) => {
    const $ = _c(18);
    const { segmentation } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== translate) {
        t1 = capitalize(translate("practical.price_details.number_guests"));
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const nbGuests = t1;
    let t2;
    if ($[2] !== translate) {
        t2 = capitalize(translate("practical.price_details.price_per_guest"));
        $[2] = translate;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    const pricePerGuest = t2;
    let t3;
    if ($[4] !== nbGuests) {
        t3 = <th className="font-semibold text-sm text-gray-500 p-2 pl-0 pr-8 last:pr-0 text-left" scope="col">
      {nbGuests}
    </th>;
        $[4] = nbGuests;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    let t4;
    if ($[6] !== pricePerGuest) {
        t4 = <th className="font-semibold text-sm text-gray-500 p-2 pl-0 pr-8 last:pr-0 text-left" scope="col">
      {pricePerGuest}
    </th>;
        $[6] = pricePerGuest;
        $[7] = t4;
    }
    else {
        t4 = $[7];
    }
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = <thead><tr className="border-b border-gray-120">{t3}{t4}
      </tr>
    </thead>;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    }
    else {
        t5 = $[10];
    }
    let t6;
    if ($[11] !== segmentation) {
        t6 = segmentation.map(_temp);
        $[11] = segmentation;
        $[12] = t6;
    }
    else {
        t6 = $[12];
    }
    let t7;
    if ($[13] !== t6) {
        t7 = <tbody>{t6}
    </tbody>;
        $[13] = t6;
        $[14] = t7;
    }
    else {
        t7 = $[14];
    }
    let t8;
    if ($[15] !== t5 || $[16] !== t7) {
        t8 = <table className="w-full">{t5}{t7}
    </table>;
        $[15] = t5;
        $[16] = t7;
        $[17] = t8;
    }
    else {
        t8 = $[17];
    }
    return t8;
};
export default SegmentationTable;
function _temp(line) { return <SegmentationLine key={`${line.participantsRange.lower}`} {...line}/>; }
